import { addDoc, collection, serverTimestamp, getFirestore } from 'firebase/firestore';
import { getApp } from 'firebase/app';

/**
 * Push an event to the notifications_queue collection.
 * The Cloud Function notificationRouter picks it up, resolves recipients,
 * and delivers in-app + FCM notifications.
 *
 * All call sites use this function — they never write to notifications/ directly.
 */
export async function pushNotificationEvent({
  eventType,
  sourceId,
  sourceType,
  payload,
  actorUid,
  actorName,
}) {
  try {
    const db = getFirestore(getApp());
    await addDoc(collection(db, 'notifications_queue'), {
      eventType,
      sourceId:   sourceId   || null,
      sourceType: sourceType || null,
      payload:    payload    || {},
      actorUid:   actorUid   || null,
      actorName:  actorName  || null,
      processed:  false,
      createdAt:  serverTimestamp(),
    });
  } catch (err) {
    // Never let a notification failure block the main action
    console.warn('[NotificationRouter] Queue write failed:', err.message);
  }
}
